// components/NavItemButton.jsx
import React from 'react';
import PropTypes from 'prop-types';

const NavItemButton = ({ className = "", label, isActive, onClick, unReadMessagesCount, icon }) => {
    return (
        <button
            className={`tw-relative tw-w-full tw-text-left tw-px-4 tw-py-3 tw-rounded-lg tw-mb-1 tw-transition-colors
        ${isActive ? 'tw-bg-teal-100 tw-text-teal-800 tw-font-medium' : 'hover:tw-bg-gray-100'}
        ${className}
      `}
            onClick={onClick}
        >
            <div className='tw-hidden sm:tw-block tw-w-fit tw-m-auto'>{icon}</div>

            <p className="tw-m-auto tw-text-left sm:tw-text-center">{label}</p>


            {unReadMessagesCount &&
                label === "Messages" ? (
                <div className="tw-absolute tw-left-[97px] tw-bottom-[27px] tw-min-w-[20px] tw-h-[20px] tw-rounded-full tw-bg-[#65acae] tw-flex tw-justify-center tw-items-center tw-text-white tw-text-[14px] tw-px-[6px] tw-py-[4px] tw-font-extrabold tw-whitespace-nowrap">
                    <div>{unReadMessagesCount}</div>
                </div>
            ) : null}
        </button>
    );
};

NavItemButton.propTypes = {
    label: PropTypes.string.isRequired,
    isActive: PropTypes.bool,
    onClick: PropTypes.func,
};

NavItemButton.defaultProps = {
    isActive: false,
    onClick: () => { },
};

export default NavItemButton;
